import Vue from 'vue'

import { Find, FindItem } from '@/api/data-logger'
import { IPanel } from '@/types/view'

import { SelectOption } from './types'
import { DataLog, Item } from '../../types/data-log'

export interface Layout {
  i: string
  x: number
  y: number
  w: number
  h: number
  moved: boolean
}

export interface Series {
  id: number
  name: string
  chartType: string
  dataLog: string
  measurement: string
  color: string
  customQuery: string
  edit: boolean
}

export interface Model {
  // eslint-disable-next-line
  attributes: any
  component: string
  // eslint-disable-next-line
  data: any
  layout: Layout
  query: Series[]
  title: string
}

export default Vue.extend({
  props: {
    value: Object,
  },
  data() {
    return {
      model: {
        attributes: {
          form: {
            limit: 5000,
            currentPage: 1,
            rowsCount: 0,
            resolution: '1m',
            duration: '1 h',
            dataLoggerId: -1,
          },
        },
      } as IPanel,
      dataLoggerItems: [] as Item[],
      dataloggers: [] as DataLog[],
      form: {
        dataLoggerId: -1,
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        limit: 5000,
        currentPage: 1,
        rowsCount: 0,
        resolution: '1m',
        duration: '1 h',
      },
      optsDuration: [
        { value: '15 m', text: '15 minutes' },
        { value: '30 m', text: '30 minutes' },
        { value: '1 h', text: '1 hour' },
        { value: '2 h', text: '2 hours' },
        { value: '6 h', text: '6 hours' },
        { value: '12 h', text: '12 hours' },
        { value: '24 h', text: '24 hours' },
      ] as SelectOption[],
      optsResolution: [
        { value: '1s', text: '1 second' },
        { value: '10s', text: '10 seconds' },
        { value: '30s', text: '30 seconds' },
        { value: '1m', text: '1 minute' },
        { value: '2m', text: '2 minute' },
        { value: '5m', text: '5 minute' },
        { value: '10m', text: '10 minute' },
      ] as SelectOption[],
    }
  },
  computed: {
    optsDataLogger(): SelectOption[] {
      return this.dataloggers.map((d: DataLog) => {
        return { value: d.id, text: d.name }
      })
    },
  },
  methods: {
    parseInput() {
      this.model = {
        ...this.value,
        query: this.value.query.map((q: string) => JSON.parse(q)),
      }
    },
    // eslint-disable-next-line
    parseModel(): IPanel {
      return {
        ...this.model,
        query: this.model.query.map((q) => JSON.stringify(q)),
      }
    },

    async find() {
      this.dataloggers = await Find()
    },

    async findItem() {
      this.dataLoggerItems = await FindItem({
        datalogId: this.model.attributes.form.dataLoggerId,
      } as Item)
    },
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        const parsedModel = this.parseModel()
        if (JSON.stringify(val) != JSON.stringify(parsedModel)) {
          // this.model = this.value
          this.parseInput()
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', this.parseModel())
        }
      },
    },

    'model.attributes.form.dataLoggerId': async function() {
      await this.findItem()
    },
  },
  async created() {
    await this.find()
    this.form = { ...this.form, ...this.model.attributes.form }
  },
})
